module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/download-de6acb35f6c126d69a448fd807d11ccb.svg";